import request from "@/utils/request";

export default function getHomePageInfo() {
    return request({
        url: `/user/agent/getHomePageInfo`,
    })
}
